import { render, staticRenderFns } from "./properties-block-gallery.vue?vue&type=template&id=24c471ec&scoped=true"
import script from "./properties-block-gallery.vue?vue&type=script&lang=js"
export * from "./properties-block-gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c471ec",
  null
  
)

export default component.exports